import PropTypes from 'prop-types';
import React from 'react';

import { MiniCard as Card, SubTitle, Title } from './styles';

function MiniCard({ title, value, showTagsContent, loading }) {
  return (
    <Card>
      <Title>{title}</Title>
      <SubTitle>{showTagsContent(loading, value)}</SubTitle>
    </Card>
  );
}

MiniCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  showTagsContent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default MiniCard;
